{
    "page_title__customers": "Customers",
    "page_sub_title__customers": "Here you find which of your customers need an appointment next. You see the customers you are responsible for, with figures and status as in your ERP. The quick views above are ready-made lists for that.",
    "quick_filters__customers_my_plus_customers": "🚀 Largest Expansion Potential",
    "quick_filters__customers_my_minus_customers": "⚠️ Strongest Churn",
    "filter_menu_title__sales_rep": "Sales Representative",
    "filter_menu_title__city": "City",
    "filter_menu_title__zip_code": "Zip Code",
    "filter_menu_title__industry": "Industry",
    "filter_menu_title__insights": "Sales Recommendations",
    "filter_menu_title__status": "Status",
    "filter_menu_title__company": "Sales Location",
    "filter_menu_title__customer_class": "Customer Type",
    "filter_menu_title__sales_region": "Sales Region",
    "filter_menu_title__customer": "Customer",
    "customer_search_placeholder": "Search by name, customer no., ZIP, city",
    "table_header__name": "Customer",
    "table_header__ttm_current": "Revenue 12 Months",
    "table_header__order_sum_ttm_current": "Order Sum 12 Months",
    "table_header__ttm_delta": "Delta 12 Months",
    "table_header__revenue_ytd": "Revenue YTD",
    "table_header__order_sum_ytd": "Order Sum YTD",
    "table_header__revenue_ytd_delta": "Delta YTD",
    "table_header__last_order_date": "Last order",
    "table_header__primary_rep": "Primary Rep",
    "table_header__city": "City",
    "table_header__industry": "Industry",
    "table_header__status": "Status",
    "table_header__expansion_potential": "Largest Expansion Potential",
    "table_header__revenue_decline": "Churn",
    "table_header__gm_ttm": "GM 12 Months",
    "table_header__gm_ttm_percent": "GM % 12 Months",
    "table_header__gm_ttm_delta": "Delta GM 12 Months",
    "table_header__gm_ytd": "GM YTD",
    "table_header__gm_ytd_percent": "GM % YTD",
    "table_header__gm_ytd_delta": "Delta GM YTD",
    "status_new": "New",
    "status_active": "Active",
    "status_at_risk": "At risk",
    "status_inactive": "Inactive",
    "status_blocked": "Blocked",
    "status_dormant": "Dormant",
    "status_tooltip": "Plato helps you prioritize customers. Plato derives the first four statuses from order activity and risk signals:",
    "status_tooltip_new": "just started ordering",
    "status_tooltip_active": "ordering regularly",
    "status_tooltip_at_risk": "showing churn signals",
    "status_tooltip_dormant": "no orders in 6+ months",
    "status_tooltip_inactive": "marked inactive in Plato, can be undone in Plato. No recommendations",
    "status_tooltip_blocked": "blocked in the ERP, can only be changed in the ERP. No recommendations",
    "table_footer__sum": "Sum",
    "table_header__visit_count": "Documented Visits",
    "table_header__visits_per_100k": "Visits / €100k",
    "visits_per_100k_tooltip": "Number of visits per €100k of revenue over the last 12 months. Shows whether visit effort matches customer size — useful for spotting small customers absorbing many visits and large ones being under-visited. Visits logged as “not reached” don't count. Only calculated for customers with at least €1k of revenue.",
    "table_header__last_visit": "Last Visit",
    "last_visit_tooltip": "Date of the most recent visit to this customer.",
    "leads__create_action": "New lead",
    "leads__create_submit": "Create lead",
    "leads__create_success": "Lead “{{name}}” created",
    "leads__create_error": "The lead could not be created",
    "leads__field_name": "Company",
    "leads__field_street": "Street",
    "leads__field_zip_code": "Zip code",
    "leads__field_city": "City",
    "leads__create_hint_label": "Note:",
    "leads__create_hint": "For leads that are not in the ERP yet. The customer is created as a lead in Plato, with no revenue and without being sent to the ERP."
}
